// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetMessagesRequest, TGetMessagesModel, IMappers, TGetMessagesResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2GetMessages } from '../../entities/get_messages_response/V2GetMessages';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetMessagesModel(parameters: IGetMessagesRequest): TGetMessagesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'cian-chat-bot',
    pathApi: '/v2/get-messages/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetMessagesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMessagesRequest;
}

export async function fetchGetMessages<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMessagesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetMessagesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetMessagesModel(parameters),
    config,
  )) as FetchResponse<TGetMessagesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2GetMessages, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetMessagesResponse>;
}
